import React from "react";
import {
  Button,
  Container,
  Form,
  FormControl,
  Nav,
  Navbar,
  NavDropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { HashLink, NavHashLink } from "react-router-hash-link";

const NavMenu = () => {
  return (
    <div>
      <Navbar className="nav-bar" fixed="top" variant="dark" expand="lg">
        <Container>
          <Navbar.Brand as={Link} to="/home">
            <spam className="primary-color">Md</spam> Hasib
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto me-3">
              <Nav.Link as={Link} to="/home">
                Home
              </Nav.Link>
              <Nav.Link as={NavHashLink} to="/home#portfolio">
                Portfolio
              </Nav.Link>
              <Nav.Link as={NavHashLink} to="/home#about">
                About me
              </Nav.Link>
              <Nav.Link as={NavHashLink} to="/home#skills">
                Skills
              </Nav.Link>
              <Nav.Link as={NavHashLink} to="/home#service">
                Service
              </Nav.Link>
              <Nav.Link as={NavHashLink} to="/blogs">
                Blogs
              </Nav.Link>
            </Nav>
            <NavHashLink to="/home#contact">
              <button className="primary-btn">Contact</button>
            </NavHashLink>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavMenu;
